<template>
  <fb-list-body :pager="pager" :showSearchForm="true" :showBtnGroup="true"
                @handlePagerSizeChange="handlePagerSizeChange" @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="btn-group">
      <el-button icon="el-icon-plus" @click="$router.push('/inform-add')">{{ $t('lang.新增') }}</el-button>
      <el-button icon="el-icon-delete" @click.native="handleBatchDelete">{{ $t('lang.删除') }}</el-button>
    </template>

    <template slot="search-form">
      <div @keyup.enter="handleSearch">
        <el-form-item class="search-form-item" :label="$t('lang.通知编号')">
          <el-input :placeholder="$t('lang.通知编号')" clearable v-model="searchForm.number"></el-input>
        </el-form-item>

        <el-form-item class="search-form-item" :label="$t('lang.推送方式')">
          <el-select :placeholder="$t('lang.全部')" clearable v-model="searchForm.pushType">
            <el-option v-for="i in pushTypeList" :key="i.value + '_key'" :label="$t(`lang.${i.name}`)" :value="i.value"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item class="search-form-item" :label="$t('lang.推送时间')">
          <el-date-picker
              v-model="time"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="~"
              :start-placeholder="$t('lang.开始日期')"
              :end-placeholder="$t('lang.结束日期')">
          </el-date-picker>
        </el-form-item>

        <el-form-item class="search-form-item" label="">
          <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{ $t('lang.搜索') }}</el-button>
          <el-button size="mini" type="primary" @click="handleReset">{{ $t('lang.重置') }}</el-button>
        </el-form-item>
      </div>
    </template>


    <template slot="table">
      <el-table :data="tableData" @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="50"></el-table-column>

        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="number" :label="$t('lang.通知编号')"></el-table-column>
        <el-table-column prop="pushTypeName" :label="$t('lang.推送方式')"></el-table-column>
        <el-table-column prop="title" :label="$t('lang.标题')"></el-table-column>
        <el-table-column prop="content" :label="$t('lang.内容')"></el-table-column>
        <el-table-column prop="statusName" :label="$t('lang.状态')"></el-table-column>
        <el-table-column prop="actualPushTimeStr" :label="$t('lang.推送时间')"></el-table-column>
        <el-table-column prop="pushCount" :label="$t('lang.接受设备数')"></el-table-column>
        <el-table-column prop="readCount" :label="$t('lang.已读设备数')"></el-table-column>

        <el-table-column fixed="right" :label="$t('lang.操作')" width="280">
          <template slot-scope="scope">
            <el-button v-if="scope.row['status'] == 'unpushed'" size="mini" @click='$router.push({path: "/inform-edit",query: {code: scope.row.code} });' plain
                       type="primary">{{ $t('lang.编辑') }}
            </el-button>
            <el-button v-if="scope.row['status'] == 'unpushed'" size="mini"  plain type="primary" @click="handlePush(scope.row)">
              {{ $t('lang.推送') }}
            </el-button>
            <el-button size="mini" @click='$router.push({path: "/inform-detail",query: {code: scope.row.code} });' plain
                       type="primary">{{ $t('lang.查看') }}
            </el-button>
            <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">{{ $t('lang.删除') }}</el-button>
          </template>
        </el-table-column>


      </el-table>
    </template>


  </fb-list-body>
</template>

<script>
export default {
  name: "InformList",
  components: {},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime()
      }
    },
  },
  data() {
    return {
      api: {
        list: this.$api.inform.list,
        delete: this.$api.inform.delete,
        batchDelete: this.$api.inform.batchDelete,
        push: this.$api.inform.push,
      },
      searchForm: {
        brandOwnerCode: this.$store.state.userInfo['brandOwnerCode']
      },
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      value: [],
      time: '',
      pushTypeList: [
        {name: "全体发送", value: 'all'},
        {name: "限定地区", value: 'region'},
        {name: "限定用户", value: 'user'},
        {name: "限定产品", value: 'product'},
      ]
    }
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    },
  },
  watch: {
    time: {
      handler(val) {
        const vm = this;
        if (val.length) {
          vm.searchForm['startTime'] = val[0];
          vm.searchForm['endTime'] = val[1];
        }
      },
      immediate: true,
      deep: true,
    },
    timestamp() {
      this.handleGetData();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {

        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true
    }

  },
  methods: {
    handlePush(row) {
      const vm = this;
      vm.$confirm(vm.$t('lang.您现在正在进行推送操作, 是否继续?'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {
        vm.$http.get(vm.api.push, {params: {code: row.code}}).then(res => {
          if(res.data.status != 200) {
            vm.$message.error(res.data.desc);
            return;
          }

          vm.$message.success(vm.$t('lang.推送成功'));
          this.handleGetData();
        })
      })

    },
    handleSearch() {
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleGetData();
    },
    handleReset() {
      this.time = ''
      if (Object.keys(this.searchForm).length) {
        this.searchForm = {
          brandOwnerCode: this.$store.state.userInfo['brandOwnerCode']
        };
        this.pager.pageIndex = 1;
        this.pager.pageSize = 10;
        this.pager.itemCount = 0;
        this.handleGetData();
      }
    },

    handleDelete(row) {


      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(vm.api.delete, vm.$qs.stringify({
          code: row.code
        })).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });

    },
    handleBatchDelete() {


      let vm = this;

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }


      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });


      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(this.api.batchDelete, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });


    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleGetData() {
      let vm = this;
      this.searchParams.brandOwnerCode = JSON.parse(sessionStorage.getItem("login-user-info")).brandOwnerCode
      this.$http.post(this.api.list, this.$qs.stringify(this.searchParams)).then((resp) => {


        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }

        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;

      })
    }
  },
  created() {

    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  }
}
</script>

<style scoped>

</style>
